import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Http } from "@angular/http";

import { environment } from "environments/environment";
import { AutorizacaoStatusExibicaoRequest, StatusAutorizacao, StatusExibicaoAutorizacao } from 'app/models';

@Injectable()
export class StatusExibicaoAutorizacaoService {
  private API_URL: string = environment.apiUrl;

  constructor(
    private http: Http,
  ) { }

  obterStatusExibicao(): Observable<StatusExibicaoAutorizacao[]> {
    return this.http.get(`${this.API_URL}StatusExibicaoAutorizacao`)
      .map(
        response => response.json(),
        error => error.json()
      );
  }

  obterStatusAutorizacao(): Observable<StatusAutorizacao[]> {
    return this.http.get(`${this.API_URL}StatusExibicaoAutorizacao/status-autorizacao`)
      .map(
        response => response.json(),
        error => error.json()
      );
  }

  public salvarStatusExibicao(data: AutorizacaoStatusExibicaoRequest) {
    const url = `${this.API_URL}StatusExibicaoAutorizacao`;
    return this.http.post(url, data).map(
      res => res.json(),
      error => error.json()
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/app-services/status-exibicao-autorizacao.service.ts